module.exports = __webpack_public_path__ + "img/login_bg_bendi.c1f7e676.png";